// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__BVCpg","modalClose":"modal_modalClose__tndW+"};